import { render, staticRenderFns } from "./BDC_LAYOUT.vue?vue&type=template&id=7251af2c&scoped=true"
import script from "./BDC_LAYOUT.vue?vue&type=script&lang=js"
export * from "./BDC_LAYOUT.vue?vue&type=script&lang=js"
import style0 from "./BDC_LAYOUT.vue?vue&type=style&index=0&id=7251af2c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7251af2c",
  null
  
)

export default component.exports